import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

const client = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });
client.interceptors.request.use((c) => {
  const t = localStorage.getItem("tt_ops_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
client.interceptors.response.use((r) => r, (err) => {
  const p = window.location.pathname;
  const inside = p.startsWith("/ops") && !p.startsWith("/ops/login");
  if (err?.response?.status === 401 && inside) {
    localStorage.removeItem("tt_ops_token");
    window.location.href = "/ops/login";
  }
  return Promise.reject(err);
});

export const opsApi = {
  login: (email, password) => client.post("/ops/auth/login", { email, password }),
  me: () => client.get("/ops/auth/me"),
  logout: () => client.post("/ops/auth/logout"),
  stats: () => client.get("/ops/stats"),
  receiving: () => client.get("/ops/receiving"),
  receive: (asn_id, items) => client.post(`/ops/receiving/${asn_id}/receive`, { items }),
  listBins: () => client.get("/ops/bins"),
  createBin: (data) => client.post("/ops/bins", data),
  binInventory: (code) => client.get(`/ops/bins/${code}/inventory`),
  inventoryAdjust: (data) => client.post("/ops/inventory/adjust", data),
  listOrders: (status) => client.get("/ops/orders", { params: status ? { status } : {} }),
  picklist: (order_id) => client.get(`/ops/orders/${order_id}/picklist`),
  pick: (order_id) => client.post(`/ops/orders/${order_id}/pick`),
  pack: (order_id) => client.post(`/ops/orders/${order_id}/pack`),
  ship: (order_id, data) => client.post(`/ops/orders/${order_id}/ship`, data),
};

const Ctx = createContext({ user: undefined });
export const OpsAuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined);
  useEffect(() => {
    opsApi.me().then((r) => setUser(r.data.user)).catch(() => setUser(null));
  }, []);
  const login = async (email, pw) => {
    const r = await opsApi.login(email, pw);
    localStorage.setItem("tt_ops_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = async () => {
    await opsApi.logout().catch(() => {});
    localStorage.removeItem("tt_ops_token");
    setUser(null);
  };
  return <Ctx.Provider value={{ user, login, logout }}>{children}</Ctx.Provider>;
};
export const useOpsAuth = () => useContext(Ctx);

export const OpsGuard = ({ children }) => {
  const { user } = useOpsAuth();
  const loc = useLocation();
  if (user === undefined) return <div className="min-h-screen grid place-items-center bg-slate-950 text-sm text-slate-400">Loading…</div>;
  if (user === null) return <Navigate to="/ops/login" state={{ from: loc }} replace />;
  return children;
};
